<template>
	<div class="page--header">
		<h2 class="text-headline">
			<slot />
		</h2>
	</div>
</template>
